import visualCapitalist from "../src/assets/Visual-Capitalist.png";
import theSound from "../src/assets/The-Sound.png";
import citrDiscorder from "../src/assets/CiTR-Discorder-01-21-2026_01_37_PM.png";
import evokeSite from "../src/assets/Evoke.png";
import anchoressSite from "../src/assets/AnchoressWebSite.jpg";
import sparrowMD from "../src/assets/Sparrow-MD.png";
import earlyOnset from "../src/assets/EarlyOnsetRecordsSite.jpg";

export const projects = [
  {
    title: "Visual Capitalist",
    subtitle: "PHP, JavaScript, CSS, MySQL",
    description: "Visual Capitalist is an online publisher with an average monthly audience of 5 million users. I design and develop pages, optimize network and database infrastructure, oversee site security, and handle a variety of revenue generating tools such as our premium subscription services and programmatic advertising.",
    image: visualCapitalist,
    link: "https://www.visualcapitalist.com/",
  },
  {
    title: "The Sound",
    subtitle: "PHP, JavaScript, CSS, MySQL",
    description: "The Sound is an international design agency. I maintain the site infrastructure creating custom backend tools for the team, while optimizing the front end for Core Web Vitals and SEO.",
    image: theSound,
    link: "https://www.thesoundhq.com/",
  },
  {
    title: "CiTR 101.9 FM / Discorder Magazine",
    subtitle: "React + Vite, WordPress API",
    description: "CiTR is a community radio station and magazine in Vancouver. I maintain the site infrastructure creating custom backend tools for the team, while optimizing the front end for Core Web Vitals and SEO.",
    image: citrDiscorder,
    link: "https://www.citr.ca/",
  },
  {
    title: "Evoke International Design",
    subtitle: "JavaScript, Liquid, CSS",
    description: "The Sound is an Vancouver-based interior design and graphic agency. I have worked on a variety of client projects from architectural firms to photographer portfolios to help them reach their full potential.",
    image: evokeSite,
    link: "https://www.evoke.ca/",
  },
  {
    title: "Anchoress",
    subtitle: "TypeScript, JavaScript, SCSS",
    description: "A multipage website for a band, built using Bootstrap and SCSS before bundling with Parcel. Hosted via cPanel. There are multiple iframes pulled from Bandcamp and YouTube. Site also includes a hidden page that must be linked to directly that is also blocked from search indexing.",
    image: anchoressSite,
    link: "https://anchoress.ca",
  },
  {
    title: "Sparrow MD",
    subtitle: "PHP, JavaScript, MySQL",
    description: "A skin clinic and aestheticians office in Vancouver. I perform routine audits of site performance and ensure medical grade security.",
    image: sparrowMD,
    link: "https://sparrowmd.ca/",
  },
  {
    title: "Early Onset Records",
    subtitle: "Shopify, Liquid",
    description: "A startup record label ecommerce platform by artists for artists, built with a Shopify template and then customized with Liquid. Primarily based around a vinyl subscription model with additional merchandise items for individual sale. Also set up a private Discord for artists and admin.",
    image: earlyOnset,
    link: "https://earlyonsetrecords.com/",
  },
];

export const skills = ["Web Development", "HTML/CSS/JS", "React", "TypeScript", "NodeJS", "PHP", "PostgreSQL", "Web Design", "UX/UI", "Digital Marketing", "SEO"];

export const testimonial = [
  {
    quote: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
    image: citrDiscorder,
    name: "Airrick Dunfield",
    company: "BCIT",
  },
  {
    quote: "Gosh wow, what a great dude and a swell developer!",
    image: earlyOnset,
    name: "Ryan Dolejsi",
    company: "Early Onset Records",
  },
];
